// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

// ASP 2026-10-11 (#1, #11): the server's allergy value is PioneerRx's allergy list, else this exact text when
// PioneerRx's own allergy status is No Known Allergies (functions/CareRx/PatientAllergySql.cs,
// NoKnownAllergies). It is a statement, not an allergy: screens show it neutral, never as a red alert.
export const NO_KNOWN_ALLERGIES = 'No known allergies (per PioneerRx)'

/** True when the value is a real allergy list (not empty, not the No Known Allergies statement). */
export const hasRealAllergies = (value?: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0 && value.trim() !== NO_KNOWN_ALLERGIES
